import { addBusinessDays, format } from "date-fns";
import React from "react";

import { selectReminderCadence } from "@performyard/engagement";
import { Text } from "@performyard/py-components";

type RemindersDetailsBoxProps = {
	frequency: number;
	nextDate: Date;
};

const RemindersDetailsBox = ({ frequency, nextDate }: RemindersDetailsBoxProps) => {
	const remindersCadence = selectReminderCadence(frequency);
	return (
		<ul className="w-full rounded-[4px] bg-neutral-2 p-2">
			<Text size="caption" weight="semi-bold">
				Scheduled Reminders:{" "}
			</Text>
			{remindersCadence.length > 0 && (
				<li>
					<Text size="caption" weight="regular" overrideElement="span">
						• {format(addBusinessDays(nextDate, remindersCadence[0]), "EEEE, MMMM d, yyyy")}
					</Text>
				</li>
			)}
			{remindersCadence.length > 1 && (
				<li>
					<Text size="caption" weight="regular" overrideElement="span">
						• {format(addBusinessDays(nextDate, remindersCadence[1]), "EEEE, MMMM d, yyyy")}
					</Text>
				</li>
			)}
			{remindersCadence.length > 2 && (
				<li>
					<Text size="caption" weight="regular" overrideElement="span">
						• {format(addBusinessDays(nextDate, remindersCadence[2]), "EEEE, MMMM d, yyyy")}
					</Text>
				</li>
			)}
		</ul>
	);
};

export default RemindersDetailsBox;
